import { mapGetters, mapActions } from 'vuex';
import $ from 'jquery';

import { NoteMixin } from '@/mixins/Note/Note';

export default {
  name: 'NoteModal',

  mixins: [NoteMixin],

  data: () => {
    return {
      isShowNote: false,

      $EditNote: null,
    };
  },

  computed: {
    ...mapGetters('Notes/NoteDetail', {
      mg_currentNote: 'currentNote',
    }),
  },

  methods: {
    ...mapActions('Notes/NoteDetail', {
      ma_updateNote: 'updateNote',
    }),

    ///
    fetchNote() {
      return this.mg_currentNote.content;
    },

    ///
    async updateNote() {
      await this.ma_updateNote({
        note: { ...this.mg_currentNote },
        objUpd: { content: this.noteContent },
      });
    },
  },

  mounted() {
    this.$EditNote = $(this.$refs.EditNote);
    this.$EditNote.on('hidden.bs.modal', () => {
      this.isShowNote = false;
    });
    this.$EditNote.on('hide.bs.modal', () => {
      this.flushSaveNote();
      //this.$emit('close-note-editor');
    });
    this.$EditNote.on('show.bs.modal', async () => {
      await this.fetchNoteAndUpdateEditor();
      this.isShowNote = true;
    });
  },

  beforeDestroy() {
    this.$EditNote.modal('hide');
  },
};
